module.exports = __webpack_public_path__ + "img/bcel.b7e94651.svg";